import React, { useEffect, useState } from "react";
import { Widget, WidgetProps } from "../widgets";
import PayPal from "../../assets/icons/PayPal.png";
import "./Donate.scss";
import homeFirefighters from "../../assets/tempImages/firefightersHome.jpeg";
import { ImageWithLayersBG } from "../ui/Media/ImageWithLayersBG";
import GalleryWidget from "../gallery/GalleryWidget";
import { WidgetType } from "../../laco-common/base/models/widget";

type ComponentProps = {} & WidgetProps;

export const Donate: React.FC<ComponentProps> = (props: ComponentProps) => {
	useEffect(() => {}, []);

	return (
		<>
			<div className="container section-padding donation-text">
				<h1 className="text-center">Your donation makes a difference.</h1>
				<h4 className="text-center mb-4">
					Our association’s vital work is made possible by generous and caring supporters, like you.
				</h4>
				<p>
					Make a gift today. Our largest expenses are for medical equipment and financial hardship for our
					firefighters in crisis. These funds go directly into members’ long-term disabilities as one of our
					major support pillars.
				</p>
				<p>
					All proceeds support our LA County firefighters. Giving is living! Your donations have a direct
					impact on our fire family members.
				</p>

				<h1 className="text-center mt-5 pt-2">Donate Now</h1>
				<div className="d-flex align-items-center donation-options my-4">
					<button
						className="btn btn-light"
						onClick={() =>
							window.open(
								props.page?.donateUrl ||
									"https://www.paypal.com/paypalme/LACFIREBW?country.x=US&locale.x=en_US"
							)
						}
					>
						<img src={PayPal} />
					</button>
					<button
						className="btn btn-light"
						onClick={() => window.open("https://buy.stripe.com/aEU3etafO17w9Fu7ss")}
					>
						<span style={{ whiteSpace: "nowrap" }}>Pay with</span>
						<i className="im im-credit-card mr-1 ml-2-5" title="Credit Card"></i>
						<i className="im im-cc-visa mr-1" title="Visa"></i>
						<i className="im im-cc-amex mr-1" title="American Express"></i>
						<i className="im im-cc-mastercard mr-1" title="Mastercard"></i>
						<i className="im im-cc-amazon mr-1" title="Amazon Pay"></i>
						<img
							className="pay-icon"
							src="https://js.stripe.com/v3/fingerprinted/img/klarna-531cd07130cfad7de4c678ef467cbeb7.svg"
							alt="Klarna"
							title="Klarna"
						/>
						{/*<img*/}
						{/*	src="https://js.stripe.com/v3/fingerprinted/img/discover-ac52cd46f89fa40a29a0bfb954e33173.svg"*/}
						{/*	alt="Discover"*/}
						{/*	title="Discover"*/}
						{/*	className="BrandIcon"*/}
						{/*	loading="lazy"*/}
						{/*/>*/}
						{/*<svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 24 24">*/}
						{/*	<path*/}
						{/*		fill="#ffffff"*/}
						{/*		d="M20.596 11.185h-.174v-.925h.184c.371 0 .573.156.573.453 0 .307-.202.472-.583.472zm-16.84-.889h-.16v2.021h.16c.385 0 .629-.074.816-.243.206-.184.33-.477.33-.77 0-.293-.124-.577-.33-.761-.197-.178-.431-.247-.816-.247zm20.244-4.296v12c0 1.104-.896 2-2 2h-20c-1.104 0-2-.896-2-2v-12c0-1.104.896-2 2-2h20c1.104 0 2 .896 2 2zm-4.173 6.835h.596v-1.228h.077l.825 1.228h.733l-.962-1.288c.449-.091.696-.398.696-.867 0-.572-.394-.902-1.082-.902h-.884v3.057zm-2.086 0h1.691v-.517h-1.095v-.825h1.055v-.518h-1.055v-.678h1.095v-.519h-1.691v3.057zm-3.208-3.057l1.297 3.135h.321l1.32-3.135h-.646l-.826 2.053-.815-2.053h-.651zm-3.094 1.545c0 .916.742 1.659 1.659 1.659.916 0 1.659-.743 1.659-1.659s-.743-1.659-1.659-1.659-1.659.743-1.659 1.659zm-2.528-.014c0 .898.705 1.595 1.613 1.595.257 0 .476-.05.747-.178v-.702c-.238.239-.449.335-.72.335-.6 0-1.027-.435-1.027-1.054 0-.587.44-1.05.999-1.05.284 0 .5.102.747.344v-.702c-.262-.133-.477-.188-.733-.188-.901 0-1.626.711-1.626 1.6zm-3.395 0c0-.902-.674-1.53-1.641-1.53h-.875v3.056h.871c.463 0 .797-.109 1.091-.353.348-.289.554-.724.554-1.173zm.87-1.531h-.596v3.056h.596v-3.056zm1.724 2.154c0 .248-.197.431-.463.431-.284 0-.513-.142-.651-.408l-.385.371c.275.403.605.582 1.058.582.62 0 1.054-.412 1.054-1.004 0-.486-.201-.705-.879-.953-.358-.132-.463-.22-.463-.385 0-.193.187-.339.444-.339.179 0 .325.073.481.247l.312-.408c-.256-.224-.563-.338-.898-.338-.541 0-.953.376-.953.876 0 .421.192.637.752.838.233.082.352.137.412.174.119.078.179.188.179.316zm14.89 1.217s-5.731 4.044-16.226 5.854h14.976c.69 0 1.25-.56 1.25-1.25v-4.604z"*/}
						{/*	/>*/}
						{/*</svg>*/}
						{/*<img*/}
						{/*	src="https://js.stripe.com/v3/fingerprinted/img/payment-methods/icon-pm-cashapp-981164a833e417d28a8ac2684fda2324.svg"*/}
						{/*	className="Icon Icon--md"*/}
						{/*	alt="Cash App"*/}
						{/*	title="Cash App"*/}
						{/*/>*/}

						{/*<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 24" fill="none">*/}
						{/*	<path*/}
						{/*		fill="#00D66F"*/}
						{/*		d="M12 24c6.6274 0 12-5.3726 12-12 0-6.62743-5.3726-12-12-12C5.37259 0 0 5.37257 0 12c0 6.6274 5.37259 12 12 12Z"*/}
						{/*	></path>*/}
						{/*	<path*/}
						{/*		fill="#011e0f"*/}
						{/*		d="M11.4479 4.80005H7.74707c.72 3.0096 2.82243 5.58235 5.45283 7.19995-2.6352 1.6176-4.73283 4.1904-5.45283 7.2h3.70083c.9168-2.784 3.456-5.2032 6.576-5.6976v-3.0095c-3.1248-.4896-5.664-2.90885-6.576-5.69285Z"*/}
						{/*	></path>*/}
						{/*</svg>*/}
						{/*<svg className="InlineSVG LinkButton-logoSvg" focusable="false" viewBox="0 0 72 24" fill="none">*/}
						{/*	<path*/}
						{/*		fill="#011E0F"*/}
						{/*		d="M36.12 3.677c0-1.128.95-2.045 2.069-2.045 1.118 0 2.069.922 2.069 2.045a2.075 2.075 0 0 1-2.07 2.069 2.057 2.057 0 0 1-2.068-2.07ZM29.98 1.92h3.6v20.16h-3.6V1.92ZM40.008 7.68h-3.629v14.4h3.629V7.68ZM66.096 14.39c2.731-1.68 4.589-4.18 5.323-6.715H67.79c-.945 2.42-3.115 4.239-5.5 5.011V1.916h-3.63v20.16h3.63V16.08c2.77.691 4.958 3.086 5.707 5.995h3.653c-.557-3.053-2.645-5.909-5.554-7.685ZM46.44 9.293c.95-1.263 2.803-1.997 4.306-1.997 2.803 0 5.121 2.05 5.126 5.146v9.633h-3.629v-8.832c0-1.272-.566-2.74-2.405-2.74-2.16 0-3.403 1.915-3.403 4.156v7.426h-3.629V7.69h3.634v1.603ZM12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"*/}
						{/*	></path>*/}
						{/*	<path*/}
						{/*		fill="#fff"*/}
						{/*		d="M11.448 4.8h-3.7c.72 3.01 2.821 5.582 5.452 7.2-2.635 1.618-4.733 4.19-5.453 7.2h3.7c.918-2.784 3.457-5.203 6.577-5.698v-3.01c-3.125-.489-5.664-2.908-6.576-5.692Z"*/}
						{/*	></path>*/}
						{/*</svg>*/}
					</button>
				</div>

				<p className="current-donations pt-4">
					<div style={{ width: "auto" }}>
						All donations given at this time will being going to support:
						<ul className="text-left">
							<li>Front-line wildland crews' immediate needs</li>
							<li>Firefighters who lost their homes in the fires </li>
							<li>Fire Camps that burned in the fires</li>
						</ul>
						Thank you for your support.
					</div>
				</p>
				<p className="donation-note">
					<div style={{ maxWidth: "70%" }}>
						Note: LA County Firefighter Benefit and Wellness Association is a charitable organization under
						[section 501(c)(3) of the Internal Revenue Code]. Contributions may be tax-deductible to the
						extent allowed by law. You will receive a donation acknowledgement recognizing your contribution
						to our Los Angeles County Fireman's Welfare Fund. EIN 95-3545877
					</div>
				</p>
			</div>
			{/*<ImageWithLayersBG url={page.id === "home" ? homeFirefighters : page.headerInnerImage} />*/}
			{/*<div className="container donation-page-video">*/}
			{/*	<Widget*/}
			{/*		widget={{*/}
			{/*			id: undefined,*/}
			{/*			widgetType: null,*/}
			{/*			component: ImageWithLayersBG,*/}
			{/*			componentProps: {*/}
			{/*				url: "https://firebasestorage.googleapis.com/v0/b/la-county-fire-dep.appspot.com/o/site%2Fsite_images%2FHeader%2FVideo%2FFires_Video.mp4?alt=media&token=98f86776-9ad0-4bf5-a94a-bbdda36e8786",*/}
			{/*				// fullSize: true,*/}
			{/*			},*/}
			{/*		}}*/}
			{/*		page={props.page}*/}
			{/*	/>*/}
			{/*</div>*/}
			{/*<div className="pb-5" style={{ clear: "both" }} />*/}

			{/*<div className="container section-padding">*/}
			{/*	<h1 className="text-center pt-2">Our Firefighters and Their Families Thank You! </h1>*/}
			{/*</div>*/}
		</>
	);
};
